
import CardInfo from "@/components/CardInfo.vue";
import Timeline from "./Timeline.vue";
import IconCandidate from "@/components/IconCandidate.vue";

export default {
  props: [
    "name",
    "role",
    "party",
    "number",
    "education",
    "ethnicity",
    "gender",
    "age",
    "timeline",
    "image",
    "status",
  ],
  components: {
    CardInfo,
    Timeline,
    IconCandidate,
  },
};
